import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Plus({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg
        width={'16px'}
        height={'16px'}
        viewBox={'0 0 16 16'}
        fill="currentColor"
      >
        <g stroke={'none'} strokeWidth={'1'} className={'icon__fill'}>
          <g transform={'translate(-4.000000, -4.000000)'}>
            <path
              d={
                'M11,5 C11,4.44771525 11.4477153,4 12,4 C12.5522847,4 13,4.44771525 13,5 L13,19 C13,19.5522847 12.5522847,20 12,20 C11.4477153,20 11,19.5522847 11,19 L11,5 Z M5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 L19,11 C19.5522847,11 20,11.4477153 20,12 C20,12.5522847 19.5522847,13 19,13 L5,13 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

Plus.propTypes = {
  className: PropTypes.string,
}
